'use strict';

var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');
var MiscInfo = require('models/misc_info');
var Notification = require('utils/notification');
var OOP = require('utils/oop');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');

// constants from models in DB and for validation
var STREET_MAX_LENGHT = 100; // model 'address'
var NUMBER_MAX_LENGTH = 20;
var CODE_MAX_LENGTH = 10;
var CITY_MAX_LENGTH = 50;
var COUNTRY_MAX_LENGTH = 50;

var NAME_MAX_LENGTH = 300; // model 'contact person'
var EMAIL_MAX_LENGTH = 50;
var TELEFON_MAX_LENGTH = 25;

var maxLength = {
    street: STREET_MAX_LENGHT,
    number: NUMBER_MAX_LENGTH,
    code: CODE_MAX_LENGTH,
    city: CITY_MAX_LENGTH,
    country: COUNTRY_MAX_LENGTH,

    name: NAME_MAX_LENGTH,
    email: EMAIL_MAX_LENGTH,
    phone: TELEFON_MAX_LENGTH,
};

// model 'misc info'
var NAME_F_MAX_LENGTH = 49;
var STR_MAX_LENGTH = 1000; // str in all (line input) text fields for values
var TEXT_MAX_LENGTH = 4000; // text area input fields

var InfoManagementDialogView = Backbone.Marionette.ItemView.extend({
    events: {
        'click .js-delete': 'deleteField',
        'click .js-add-field-line': 'addFieldLine',
        'click .js-add-field-text': 'addFieldText',

        'click button#js-success': 'validateAndSave',
    },

    initialize: function (options) {
        this.deviceId = options.deviceId;
        this.model = options.model;
        this.controller = options.controller;
        this.groupId = options.groupId;
        this.updateCallback = options.callback;
        this.template = require('components/devices/templates/common/info_management_dialog_edit_' + this.groupId);
        this.formData = $.extend(true, {}, this.model.toJSON());
        if (this.groupId == 'miscinfo') {
            this.formData.fields = this.formData.fields || [{ name: '', value: '', isTextArea: false }];
        }
    },

    onRender: function () {
        // set dialog window width to large
        $('.modal-dialog').addClass('modal-lg');
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.formData = this.formData;
        data.canView = AppState.Cache.columnMap;
        data.errors = this.errors || {};
        data.restricted = AppState.isRestricted();

        // copy field errors
        _.each(data.formData.fields, function (field, idx) {
            field.error_name = data.errors['name-' + idx];
            field.error_value = data.errors['value-' + idx];
        });
        return data;
    },

    addField: function (e, isTextArea) {
        e.preventDefault();
        this.saveContent();
        this.formData.fields.push({
            name: '',
            value: '',
            isTextArea: isTextArea,
        });
        this.render();
    },

    addFieldLine: function (e) {
        this.addField(e, false);
    },

    addFieldText: function (e) {
        this.addField(e, true);
    },

    deleteField: function (e) {
        var idx = parseInt($(e.currentTarget).attr('data-idx'));
        delete this.formData.fields[idx];
        this.formData.fields = _.compact(this.formData.fields);
        this.render();
    },

    saveContent: function () {
        var self = this;
        var form = Backbone.Syphon.serialize(this);
        if (this.groupId == 'miscinfo') {
            _.each(this.formData.fields, function (field, idx) {
                field.name = form['name-' + idx];
                field.value = field.isTextArea
                    ? form['value-' + idx + '-textarea']
                    : form['value-' + idx + '-textline'];
            });
        } else {
            _.each(form, function (value, key) {
                self.formData[key] = value;
            });
        }
    },

    validate: function () {
        var err = {};
        switch (this.groupId) {
            case 'address':
            case 'contactperson':
                _.each(this.formData, function (value, key) {
                    if (value.length > maxLength[key]) err[key] = i18n.TR('zu lang');
                });
                break;
            case 'miscinfo':
                var fields = this.formData.fields;
                for (var i = 0; i < fields.length; i++) {
                    if (fields[i]['name'].length > NAME_F_MAX_LENGTH) {
                        err['name-' + i] = i18n.TR('zu lang');
                    }
                    if (
                        fields[i]['value'].length > TEXT_MAX_LENGTH ||
                        (fields[i]['value'].length > STR_MAX_LENGTH && fields[i]['isTextArea'] == false)
                    ) {
                        err['value-' + i] = i18n.TR('zu lang');
                    }
                }
                break;
        }

        return err;
    },

    validateAndSave: function (e) {
        var self = this;
        e.preventDefault();

        this.saveContent();

        var err = this.validate();
        if (_.keys(err).length > 0) {
            // show validation errors
            this.errors = err;
            App.refreshModal(this);
            return;
        }

        var prefix = {
            address: 'addr_',
            contactperson: 'ctct_',
        };

        var modelData = {
            id: this.formData.id,
            fields: undefined,
        };

        modelData.fields = this.formData.fields
            ? _.map(
                  _.filter(this.formData.fields, function (f) {
                      return f.name.trim() != '';
                  }),
                  function (item) {
                      return {
                          field_id: item.field_id ? '' + item.field_id : undefined,
                          name: item.name,
                          value: item.value,
                          isTextArea: item.isTextArea,
                      };
                  }
              )
            : _.compact(
                  _.map(_.pairs(this.formData), function (item) {
                      if (item[0] == 'id') return undefined;
                      return { field_id: prefix[self.groupId] + item[0], value: item[1] };
                  })
              );

        var model = new MiscInfo(modelData);
        model.save(
            {},
            {
                success: function () {
                    App.hideModal();
                    self.updateCallback();
                },
                error: function (m, err) {
                    self.errors = err.responseJSON || { error: 'general_error' };
                    App.refreshModal(self);
                },
            }
        );
    },
});

module.exports = InfoManagementDialogView;
